import { render, staticRenderFns } from "./HowMuchStep.vue?vue&type=template&id=4e9d3c54&scoped=true&"
import script from "./HowMuchStep.vue?vue&type=script&lang=js&"
export * from "./HowMuchStep.vue?vue&type=script&lang=js&"
import style0 from "./HowMuchStep.vue?vue&type=style&index=0&id=4e9d3c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d3c54",
  null
  
)

export default component.exports